import types from './mutation-types';

export default {
  // Loader
  async incrementLoader(context) {
    context.commit(types.INCREMENT_LOADER);
    return context.getters.loading;
  },

  async decrementLoader(context) {
    context.commit(types.DECREMENT_LOADER);
    return context.getters.loading;
  },

  async setSignedIn(context, isSignedIn) {
    context.commit(types.SET_SIGNED_IN, isSignedIn);
    return context.getters.isSignedIn;
  },

  // Breadcrumbs

  async setViewBreadcrumbs(context, options) {
    context.commit(types.SET_VIEW_BREADCRUMBS, options);
    return context.state.breadcrumbs;
  },

  async resetViewBreadcrumbs(context, viewName) {
    context.commit(types.RESET_VIEW_BREADCRUMBS, viewName);
    return context.state.breadcrumbs;
  },
};



// WEBPACK FOOTER //
// ./store/actions.js